// Utilities related to user sign up or login.

/** The URL to go to if the user asks to sign up for an account. */
export function computeSignupHref(continuePathname: string) {
  return `/signup?continue=${encodeURIComponent(continuePathname)}`;
}

/** The URL to go to if the user asks to log in. */
export function computeLogInHref(continuePathname: string) {
  return `/login?continue=${encodeURIComponent(continuePathname)}`;
}
